module.exports = __webpack_public_path__ + "img/loading.b8ea640e.svg";